import { action, get, set, entries, keys, observable } from 'mobx';

class DemandSwitches {
  @observable switches = {};

  constructor(switches, onChange) {
    for (const [label, value] of Object.entries(switches)) {
      this.set(label, value);
    }
    this.onChange = onChange;
  }

  get empty() {
    return keys(this.switches).length === 0;
  }

  get(label) {
    return get(this.switches, label);
  }

  set(label, value) {
    if (value === null) {
      return;
    }
    set(this.switches, label, (value === true) || (value === 'true'));
  }

  entries() {
    return entries(this.switches);
  }

  onSwitchChange(label) {
    return action(event => {
      this.set(label, !this.get(label));
      this.onChange(event);
    });
  }
}


export default DemandSwitches;
